import React from 'react';
import styled from 'styled-components';

const SIDEBAR_EXPANDED_WIDTH = '276px';
const SIDEBAR_COLLAPSED_WIDTH = '56px';
const TRANSLATE_RIGHT = '45px';

const getSidebarWidth = size => {
  if (size === 'full') {
    return `calc(100vw - ${TRANSLATE_RIGHT})`;
  }
  if (size === 'collapsed') {
    return SIDEBAR_COLLAPSED_WIDTH;
  }
  return SIDEBAR_EXPANDED_WIDTH;
};

const StyledHomeLayoutContainer = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  padding-left: ${props =>
    props.repositorySize === 'full'
      ? '100vh'
      : getSidebarWidth(props.repositorySize)};
  position: absolute;
`;

const StyledLeft = styled.div`
  height: 100%;
  position: absolute;
  left: 0;
  z-index: 1;
  background-color: rgb(255, 255, 255);
  width: ${props => getSidebarWidth(props.repositorySize)};
  box-shadow: 0px 2px 6px 0px rgba(25, 25, 39, 0.25);
`;

const Styledright = styled.div`
  width: ${props => `calc(100vw - ${getSidebarWidth(props.repositorySize)})`};
  height: 100%;
  position: relative;
  z-index: 0;
  background-color: ${props => props.theme.colors.light_dark};
`;

const HorizontalSplit = ({
  left,
  children,
  repositorySize = 'default',
  repositoryHidden = false,
}) => {
  return (
    <StyledHomeLayoutContainer repositorySize={repositorySize}>
      {!repositoryHidden && (
        <StyledLeft repositorySize={repositorySize}>{left}</StyledLeft>
      )}
      <Styledright repositorySize={repositorySize}>{children}</Styledright>
    </StyledHomeLayoutContainer>
  );
};

export default HorizontalSplit;
